<template>
  <div class="row">
    <div class="col-2"></div>
    <div class="col">
      <form v-if="fields.length > 0">
        <h3 style="text-align: center">Responda o formulário</h3>
        <div class="question-form">
          <h5 class="label-form" style="text-align: center">{{ formBuilder.nomeForm }}</h5>
        </div>

        <div class="question-form" v-for="(field, index) in fields" :key="index">
          <label :for="field.id" class="label-form">{{ index + 1 }}. {{ field.label }}<b style="color: red; font-size: 15px; margin-left: 5px" v-if="field.required">*</b></label>

          <input class="form-control form-input-component" v-if="field.type === 'text'" :id="'questao' + field.id" :name="field.id" v-model="this.formCreated['questao' + field.id]" v-bind:class="{ 'is-invalid': submitted && !this.formCreated['questao' + field.id] && field.required }" type="text" />

          <textarea class="form-control form-input-component" v-if="field.type === 'textarea'" :id="'questao' + field.id" v-model="this.formCreated['questao' + field.id]" v-bind:class="{ 'is-invalid': submitted && !this.formCreated['questao' + field.id] && field.required }" :name="field.id"></textarea>

          <select class="form-control form-input-component" v-if="field.type === 'select'" :id="'questao' + field.id" v-bind:class="{ 'is-invalid': submitted && !this.formCreated['questao' + field.id] && field.required }">
            <option v-for="(option, optionIndex) in field.options" :key="optionIndex" :value="option.value">
              {{ option.label }}
            </option>
          </select>

          <div v-if="field.type === 'radio'">
            <div class="form-check" v-for="(option, optionIndex) in field.options" :key="optionIndex">
              <input class="form-check-input" type="radio" name="flexRadioDefault" v-bind:class="{ 'is-invalid': submitted && !this.formCreated['questao' + field.id] && field.required }" :id="'questao' + field.id" @click="setRadioValue(option, field)" />
              <label class="form-check-label">
                {{ option.label }}
              </label>
            </div>
          </div>

          <div v-if="field.type === 'checkbox'">
            <div class="form-check" v-for="(option, optionIndex) in field.options" :key="optionIndex">
              <input class="form-check-input" type="checkbox" value="{{option}}" v-bind:class="{ 'is-invalid': submitted && !this.formCreated['questao' + field.id] && field.required }" @click="setCheckValue(option, field)" id="flexCheckDefault" />
              <label class="form-check-label" for="flexCheckDefault">
                {{ option.label }}
              </label>
            </div>
          </div>
        </div>
        <div class="container row">
          <div class="col justify-content-end" style="margin-top: 5px">
            <div class="float-end">
              <button type="button" class="btn btn-primary" @click="salvarRespostas">Responder Formulário</button>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="col-3"></div>
  </div>
</template>

<script>
import { getFormBuilderById } from '@/components/service/formBuilderService';
import { openNotification, typesNotification } from '@/utils/notifications';
import { getDataUser } from '@/utils';
import { createRespostas } from '@/components/service/formBuilderRespostasService';
import { getByIdRegistroAtendimento } from '@/components/service/registroAtendimentoService';

export default {
  name: 'FormBuilderQuestions',
  props: {
    idFormProp: {
      type: String,
      required: false,
    },
    idRegistroAtendimento: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      fields: [],
      idForm: null,
      formBuilder: null,
      formCreated: {},
      submitted: false,
      optionsRadio: [],
      optionsCheck: [],
      formResposta: {},
    };
  },
  async created() {
    if (this.idFormProp) {
      this.$route.query.id = this.idFormProp;
    }
    if (this.$route.query.id) {
      this.idForm = this.$route.query.id;
      await this.recuperarForm();
    }
  },
  methods: {
    async recuperarForm() {
      await getFormBuilderById(this.idForm).then((form) => {
        this.formBuilder = form.data;
        this.fields = this.formBuilder.questoes;
        for (let field of this.fields) {
          this.formCreated['questao' + field.id] = undefined;
        }
      });
    },
    async salvarRespostas() {
      let respostas = [];
      this.submitted = false;
      for (let ques of this.fields) {
        if (ques.type === 'radio') {
          let filterRadio = this.optionsRadio.find((op) => op.id === ques.id);
          if (filterRadio) {
            respostas.push(filterRadio);
          } else {
            if (ques.required) {
              this.submitted = true;
              openNotification(typesNotification.warning, 'Preencher campos obrigatórios');
              break;
            }
          }
        } else if (ques.type === 'checkbox') {
          let filterCheck = this.optionsCheck.find((op) => op.id === ques.id);
          if (filterCheck) {
            respostas.push(filterCheck);
          } else {
            if (ques.required) {
              this.submitted = true;
              openNotification(typesNotification.warning, 'Preencher campos obrigatórios');
              break;
            }
          }
        } else {
          let resposta = document.getElementById('questao' + ques.id);
          if (!resposta && ques.required) {
            this.submitted = true;
            openNotification(typesNotification.warning, 'Preencher campos obrigatórios');
            break;
          }
          let objectResposta = {};
          objectResposta.id = ques.id;
          objectResposta.label = ques.label;
          objectResposta.type = ques.type;
          if (ques.type === 'select') {
            objectResposta.respostaObjeto = { label: resposta.value };
            objectResposta.options = ques.options;
          } else {
            objectResposta.respostaText = resposta.value;
          }

          respostas.push(objectResposta);
        }
      }
      let userData = getDataUser();
      this.formResposta.idFormBuilder = this.idForm;
      this.formResposta.nomeForm = this.formBuilder.nomeForm;
      this.formResposta.respostas = respostas;
      this.formResposta.nomeUsuario = userData.nome;
      this.formResposta.cpfUsuario = userData.cpf;
      await getByIdRegistroAtendimento(this.idRegistroAtendimento).then((r) => {
        this.formResposta.registroAtendimento = r.data;
      });

      if (!this.submitted) {
        await createRespostas(this.formResposta).then(() => {
          openNotification(typesNotification.success, 'Formulário respondido com sucesso.');
          this.$emit('reload-table', { reload: true });
        });
      }
    },
    setRadioValue(option, field) {
      let radioValue = {};

      radioValue.id = field.id;
      radioValue.label = field.label;
      radioValue.type = field.type;
      radioValue.respostaObjeto = option;
      radioValue.options = field.options;

      let changeValue = this.optionsRadio.find((op) => op.id === field.id);
      if (changeValue) {
        this.optionsRadio.splice(this.optionsRadio.indexOf(changeValue), 1);
      }
      this.optionsRadio.push(radioValue);
    },
    setCheckValue(option, field) {
      let checkValue = {};
      let op = this.optionsCheck.find((oc) => oc.id === field.id);
      if (op) {
        let opItem = op.respostaOptions.find((opi) => opi.label === option.label);
        if (opItem) {
          op.respostaOptions.splice(op.respostaOptions.indexOf(opItem), 1);
          if (op.respostaOptions.length === 0) {
            this.optionsCheck.splice(this.optionsCheck.indexOf(op), 1);
          }
        } else {
          op.respostaOptions.push(option);
        }
      } else {
        checkValue.id = field.id;
        checkValue.label = field.label;
        checkValue.type = field.type;
        checkValue.respostaOptions = [option];
        checkValue.options = field.options;
        this.optionsCheck.push(checkValue);
      }
    },
  },
};
</script>

<style scoped>
#uploadImg {
  display: none;
}

.question-form {
  background: white;
  padding: 26px;
  border-radius: 10px 10px;
  margin-bottom: 10px;
}

.label-form {
  margin-bottom: 25px;
  font-family: ROBOTO, serif;
  font-size: 23px;
}

.form-check {
  font-size: 18px;
}
</style>
